/**
 * Era Digital — Brand & Design System Reference
 * Extracted from the production landing page at eradigital.ai
 *
 * Import and use these constants to keep the platform visually aligned
 * with the landing page design system.
 */

export const BRAND = {
  // ── Colors ──────────────────────────────────────────────────────
  colors: {
    navy: '#0A1F44',
    orange: '#F7931A',
    orangeGlow: 'rgba(247, 147, 26, 0.25)',
    ocean: '#4A90A4',
    bgLight: '#F5F7FA',
    white: '#FFFFFF',
    grayText: '#5A6577',
  },

  // ── Gradients ───────────────────────────────────────────────────
  gradients: {
    hero: 'linear-gradient(165deg, #0A1F44 0%, #0f2a55 35%, #0A1F44 100%)',
    darkBreak: 'linear-gradient(135deg, #0A1F44 0%, #1a3a6a 40%, #0f2a55 100%)',
    lightBreak: 'linear-gradient(160deg, #F5F7FA 0%, #e8ecf2 50%, #F5F7FA 100%)',
    primaryButton: 'linear-gradient(to right, #F7931A, #e8850f)',
    orangeRadial: 'radial-gradient(ellipse 60% 50% at 50% 40%, rgba(247,147,26,0.06), transparent)',
    oceanRadial: 'radial-gradient(ellipse 40% 40% at 80% 20%, rgba(74,144,164,0.1), transparent)',
  },

  // ── Shadows ─────────────────────────────────────────────────────
  shadows: {
    card: '0 2px 12px rgba(0,0,0,0.08)',
    cardHover: '0 8px 32px rgba(0,0,0,0.14)',
    hero: '0 20px 60px rgba(0,0,0,0.18), 0 4px 16px rgba(0,0,0,0.1)',
    orangeGlow: '0 4px 20px rgba(247, 147, 26, 0.3)',
  },

  // ── Typography ──────────────────────────────────────────────────
  fonts: {
    heading: "'Playfair Display', Georgia, serif",
    body: "'DM Sans', system-ui, -apple-system, sans-serif",
  },

  // ── Spacing & Layout ───────────────────────────────────────────
  layout: {
    maxWidth: '1400px',
    contentWidth: '1200px',
    narrowWidth: '900px',
    cardRadius: '12px',
    largeCardRadius: '16px',
    buttonRadius: '8px',
  },

  // ── Animation ───────────────────────────────────────────────────
  animation: {
    ease: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    easeOut: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
    duration: '0.3s',
  },

  // ── Assets ──────────────────────────────────────────────────────
  logo: '/era-logo.jpg',

  // ── Brand Copy ──────────────────────────────────────────────────
  name: 'Era Digital',
  tagline: 'Bridging DeFi and TradFi',
  brandLine: "You're the pilot, Era is your co-Pilot",
  headline: 'Your Command Center for Market Intelligence',
  subheadline: 'Real-time data, AI-powered insights, and educational tools — all in one platform.',
};

export default BRAND;
